import { createApi} from '@reduxjs/toolkit/query/react';
import {fetchBaseQueryWithReauth} from './fetchBaseQueryWithReauth'

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery:fetchBaseQueryWithReauth,
  tagTypes: ['Meeting', 'Family', 'Task', 'Notification', 'Mentor', 'User', 'Calendar'],
  endpoints: () => ({}),
});
